module.exports = __webpack_public_path__ + "img/process.0d14aae9.jpg";